import React from 'react';
import { BuildTipWrapper } from './BuildTipStyle';
import { BuildTipItem } from 'sofa-reborn-react';
import Image from '@ingka/image';

type BuildTipProps = {
	buildTipItem: BuildTipItem;
	hideBuildTip: boolean;
};

const BuildTip = (props: BuildTipProps) => {
	return (
		<BuildTipWrapper
			top={props.buildTipItem.top}
			left={props.buildTipItem.left}
			hideBuildTip={props.hideBuildTip}
		>
			<Image src={props.buildTipItem.src} alt={props.buildTipItem.alt} />
		</BuildTipWrapper>
	);
};

export default BuildTip;
